import { createContext, ReactNode, useMemo } from 'react';

export type Device = 'mobile' | 'desktop';
export type Theme = 'boozt' | 'booztlet';

interface Context {
    device?: Device;
    theme?: Theme;
    translate: Function;
    svgPath?: string;
    logoPath?: string;
}

interface ContextProps {
    device?: Device;
    theme?: Theme;
    children?: ReactNode;
    translate?: Function;
    svgPath?: string;
    logoPath?: string;
}

function translateFallback(key: string, _arguments: object, _translations: object, fallback: string) {
    return fallback || key;
}

export const ConfigContext = createContext<Context>({
    translate: translateFallback,
    theme: 'boozt',
    svgPath: '',
});

ConfigContext.displayName = 'PaletteConfigContext';

function PaletteConfigProvider({
    children,
    device,
    theme = 'boozt',
    svgPath = '',
    logoPath,
    translate = translateFallback,
}: ContextProps) {
    const contextValue = useMemo(() => ({
        device,
        theme,
        svgPath,
        logoPath,
        translate,
    }), [
        device,
        logoPath,
        svgPath,
        theme,
        translate,
    ]);

    return (
        <ConfigContext.Provider value={contextValue}>
            {children}
        </ConfigContext.Provider>
    );
}

export default PaletteConfigProvider;

export type { ContextProps };
